module.exports = require('./dist/src/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/groupby-api/index.js
 ** module id = 102
 ** module chunks = 0
 **/